<template>
  <div>
    <div class="item" @click="checkPicture(1)">
      <div>互联网新闻信息服务许可证</div>
      <i class="arrow-right"></i>
    </div>
    <div class="item" @click="checkPicture(2)">
      <div>信息网络传播视听节目许可证</div>
      <i class="arrow-right"></i>
    </div>
    <div class="item" @click="checkPicture(3)">
      <div>软著证书</div>
      <i class="arrow-right"></i>
    </div>
    <div class="item" @click="checkPicture(4)">
      <div>域名证书</div>
      <i class="arrow-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = '牌照资质'
  },
  methods: {
    checkPicture(id) {
      this.$router.push({
        path: '/credential-picture',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.item {
  width 690px
  background #F5F5F9
  border-radius 20px
  height 88px
  font-size 30px
  color #333333
  display flex
  align-items center
  padding 0 30px
  margin 20px auto 0
  justify-content space-between

  .arrow-right {
    position relative
  }

  .arrow-right:after, .arrow-right:before {
    border 15px solid transparent
    border-left 15px solid #F5F5F9
    width 0
    height 0
    position absolute
    top -13px
    right -20px
    content ' '
  }

  .arrow-right:before {
    border-left-color #1A1A1A
    right -21px
  }
}
</style>
